import { Component, Input, OnInit } from '@angular/core';
import { AbstractTemplateBox } from '../../general-modals/select-template/select-template-box/abstract-template-box';
import { AuthHelperService } from 'app/auth/helpers/auth-helper.service';
import { AuthenticationService } from 'app/auth/service';
import { IntegrationService } from 'app/global/integrations/integrations.service';
import { PipeDriveService } from 'app/global/integrations/pipedrive/pipe-drive.service';
import { UploadsService } from 'app/global/uploads.service';
import { AuthFacade } from 'app/store/auth.facade';
import { HelperService } from '../../edit-template/helper.service';
import { SelectTemplateService } from '../../general-modals/select-template/select-template.service';
import { DocumentTypeService } from '../../settings/documenttype/document-type.service';
import { TemplateService } from '../../templates/templates.service';
import { SharedStoreFacade } from 'app/main/shared/shared/store/shared-store.facade';

@Component({
  selector: 'app-iframeable-select-template',
  templateUrl: './iframeable-select-template.component.html',
  styleUrl: './iframeable-select-template.component.scss'
})
export class IframeableSelectTemplateComponent extends AbstractTemplateBox implements OnInit{
  @Input() view: string = 'simplesign';

  constructor(
      private _authHelper: AuthHelperService,
      protected templateService: TemplateService,
      protected documentTypeService: DocumentTypeService,
      protected selectTemplateService: SelectTemplateService,
      protected _authFacade$: AuthFacade,
      protected pipeDriveService: PipeDriveService,
      protected helperService: HelperService,
      protected integrationService: IntegrationService,
      protected _authenticationService: AuthenticationService,
      protected _uploadingService$: UploadsService,
      protected _sharedStoreFacade$: SharedStoreFacade,
    ) {
    super(
      templateService,
      documentTypeService,
      selectTemplateService,
      _authFacade$,
      pipeDriveService,
      helperService,
      integrationService,
      _authenticationService,
      _uploadingService$,
      _sharedStoreFacade$
    )
  }

  async ngOnInit() {
    this._authHelper.setLayoutConfig(true, false, false);
    await this.initIntegration();
  }
}
